import {AbstractControl} from '@angular/forms';
import {Base, BaseDTO} from './base';
import { Tenants } from './tenants';

export interface ClosuresFilters {
    closure_date?: Date;
    tenant_id?: number;
    onlyCurrentTenant?: boolean;
}

export interface ClosuresDTO extends BaseDTO{
    closure_date: string;
    tenant_id: number;
    tenant?: Tenants;
    
}

export class Closures extends Base {
    closureDate: Date;
    tenantId: number;
    


    constructor(source: ClosuresDTO){
        super(source);
        if(source){
            //this.closureDate = new Date(source.closure_date);
            // this.closureDate = source.closure_date ? new Date(source.closure_date + 'T00:00:00') : null;
            this.closureDate = source.closure_date ? new Date(source.closure_date) : null;
            this.tenantId = source.tenant_id;
            

        }
    }

    toDTO(): ClosuresDTO {
        //console.log("Closure Date before conversion:", this.closureDate);
        return {
            ...super.toDTO(),
            closure_date: this.closureDate
            ? new Date(this.closureDate.getTime() - this.closureDate.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0]
            : null,

            tenant_id: this.tenantId,
            

        };
        // let result: ClosuresDTO = <ClosuresDTO>super.toDTO();
        // result.closure_date = this.closureDate.toISOString().split('T')[0];
        // result.tenant_id = this.tenantId;


        // return result;
    }

    static fromFormGroup(formGroup: AbstractControl, original?: Closures){
        const formModel = formGroup.value;
        //console.log("Form Model:", formModel);
        let closures = new Closures(null);
        
        closures.closureDate = formModel.closure_date instanceof Date
            ? formModel.closure_date
            : formModel.closure_date
            ? new Date(formModel.closure_date + 'T00:00:00')
            : null;    
        
        closures.tenantId = formModel.tenant_id;


        if(original) {
            closures.id = original.id;
        }

        return closures;
    }
}

